// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});

	// Function to handle the dropdown hover only on desktop
    function handleDropdownHover() {
        // Remove existing event listeners
        document.querySelectorAll('.dropdown').forEach(function (dropdown) {
            // Check if window width is greater than or equal to 768px
            if (window.innerWidth >= 768) {
                dropdown.addEventListener('mouseenter', function () {
                    let menu = this.querySelector('.dropdown-menu');
                    menu.classList.add('show');
                });

                dropdown.addEventListener('mouseleave', function () {
                    let menu = this.querySelector('.dropdown-menu');
                    menu.classList.remove('show');
                });
            }
        });
    }

    // Run the function on page load
    handleDropdownHover();

    // Re-run the function on window resize to ensure responsiveness
    window.addEventListener('resize', function () {
        // Clear previous event listeners to prevent stacking
        document.querySelectorAll('.dropdown-menu').forEach(function (menu) {
            menu.classList.remove('show');
        });
        handleDropdownHover();
    });


    document.addEventListener("DOMContentLoaded", function () {
        const currentUrl = window.location.href;
        const menuItems = document.querySelectorAll("#menu-left-menu > .nav-item");

        // Extract URL path pieces after the domain, e.g., ["our-company", "leadership"]
        const urlPathPieces = window.location.pathname.split("/").filter(piece => piece);

        if (urlPathPieces.length >= 2) { // Ensure there are at least two pieces
            const [urlPiece1, urlPiece2] = urlPathPieces; // Get the first two pieces

            menuItems.forEach((menuItem) => {
                const anchor = menuItem.querySelector("a");

                // Check if the menu item has a dropdown with child items
                const dropdownItems = menuItem.querySelectorAll(".dropdown-item");
                let isMatch = false;

                // Check if any child item matches both URL pieces
                dropdownItems.forEach((dropdownItem) => {
                    if (dropdownItem.href.includes(urlPiece1) && dropdownItem.href.includes(urlPiece2)) {
                        isMatch = true;
                    }
                });

                // If a matching child item is found, add the 'active' class to the parent item
                if (isMatch) {
                    menuItem.classList.add("active");
                }
            });
        }
    });
})();
